import React, { useEffect, useState } from "react"

const leftItems = [
  {
    title: "Executive stress & Burnout",
    subtitle: "Managing high level workplace stress and fatigue"
  },
  {
    title: "Anxiety disorders and phobias",
    subtitle: "Treating excessive fear, phobias, and panic"
  },
  {
    title: "LGBTQ+ Affirmative Therapy",
    subtitle: "Supportive counselling for LGBTQ+ individuals"
  },
  {
    title: "Adjustment to Life Changes & Stressful Events",
    subtitle: "Helping navigate major life transitions"
  },
  {
    title: "Self esteem difficulties",
    subtitle: "Addressing issues of self worth and confidence"
  },
  {
    title: "Identity sexuality and gender related concerns",
    subtitle: "Creating space to explore identity with care and clarity"
  }
]

const rightItems = [
  {
    title: "General anxiety and chronic worry",
    subtitle: "Easing persistent worry and chronic anxiety"
  },
  {
    title: "Depression and low mood",
    subtitle: "Improving low mood and motivation"
  },
  {
    title: "Post traumatic stress reactions",
    subtitle: "Support for trauma and post traumatic stress"
  },
  {
    title: "Sleep related difficulties",
    subtitle: "Addressing insomnia and sleep problems"
  },
  {
    title: "Compassion focused work including shame and stigma",
    subtitle: "Building self compassion and reducing shame"
  },
  {
    title: "Meaning purpose and values based work",
    subtitle: "Exploring direction purpose and personal values"
  }
]

export default function BenExperience() {
  const [isStacked, setIsStacked] = useState(false)
  const [showMore, setShowMore] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsStacked(window.innerWidth < 768)
    }

    checkScreenSize()
    window.addEventListener("resize", checkScreenSize)

    return () => window.removeEventListener("resize", checkScreenSize)
  }, [])

  const visibleLeftItems = isStacked && !showMore ? leftItems.slice(0, 3) : leftItems
  const visibleRightItems = isStacked && !showMore ? rightItems.slice(0, 3) : rightItems

  return (
    <section id="experience" className="benExperienceSection">
      <div className="profile-container">
        <div className="benExperienceIntro">
          <div className="benExperienceEyebrowWrap">
            <span className="benExperienceEyebrowLine"></span>
            <p className="benExperienceEyebrow mb-0">SPECIALIST AREAS</p>
            <span className="benExperienceEyebrowLine"></span>
          </div>

          <h2 className="benExperienceHeading mb-0">
            Areas of Experience
          </h2>

          <p className="benExperienceLead mb-0">
            Support offered across a range of emotional, psychological and identity related concerns.
          </p>
        </div>

        <div className="benExperienceGrid">
          <div className="benExperienceColumn">
            {visibleLeftItems.map((item, index) => (
              <div className="benExperienceItem" key={index}>
                <div className="benExperienceTitleRow">
                  <span className="benExperienceBullet"></span>
                  <h3 className="benExperienceItemTitle mb-0 fw-bold">{item.title}</h3>
                </div>
                <p className="benExperienceItemSubtitle mb-0">{item.subtitle}</p>
              </div>
            ))}
          </div>

          <div className="benExperienceColumn">
            {visibleRightItems.map((item, index) => (
              <div className="benExperienceItem" key={index}>
                <div className="benExperienceTitleRow">
                  <span className="benExperienceBullet"></span>
                  <h3 className="benExperienceItemTitle mb-0 fw-bold">{item.title}</h3>
                </div>
                <p className="benExperienceItemSubtitle mb-0">{item.subtitle}</p>
              </div>
            ))}
          </div>
        </div>

        {isStacked && (
          <div className="text-center mt-4">
            <button
              className="btn btn-brand-primary fw-bold"
              onClick={() => setShowMore(!showMore)}
            >
              {showMore ? "Show less" : "Show more"}
            </button>
          </div>
        )}
      </div>
    </section>
  )
}